export default __webpack_public_path__ + "static/media/ceramic-image.5f628b84.png";